import Vue from 'vue'
import {
    AclRule
} from 'vue-acl'

import Router from 'vue-router'
import store from './store/store'
import LoginPage from './components/login.vue'
import DashboardPage from './components/dashboard.vue'
import Overview from './components/overview'

import PromotionCreatePage from './components/promotion/create.vue'
import PromotionManagePage from './components/promotion/manage.vue'
import PromotionTrackPage from './components/promotion/track.vue'
import PromotionReportPage from './components/promotion/report.vue'

import CampaignCreatePage from './components/campaign/create.vue'
import CampaignManagePage from './components/campaign/manage.vue'
import CampaignRewardPage from './components/campaign/rewardPage.vue'
import CampaignTrackPage from './components/campaign/track.vue'
import CampaignRepotPage from './components/campaign/Report.vue'
import CampaignConfig from './components/campaign/Config.vue'

import SettingMyAccountPage from './components/setting/myaccount.vue'
// import SettingUserManagementPage from './components/setting/usermanage.vue'
import SettingAboutPage from './components/setting/about.vue'

import CustomerGroup from './components/system/customer-group.vue'

// Pricing
import VolumePricingPage from './components/pricing/volume-pricing.page'
import ProductsPage from './components/pricing/products.page'
import PricingListPage from './components/pricing/pricing-list.page'
import VolumePricingReportPage from './components/pricing/report.vue'
import BookPricePage from './components/pricing/book-price.vue'
import RequestPricePage from './components/pricing/bookprice/request-price.vue'
import MessagePage from './components/pricing/bookprice/message.vue'

import DefaultLayout from './components/layout/default'

import publicPage from './components/test/publicPage'
import adminPage from './components/test/adminPage'

import PageNotFound from './components/pageNotFound.vue'
import AccessDenied from './components/accessDenied.vue'
import MaintenancePage from './components/maintenance.vue'

import Users from './components/system/users';
import ConfigSystem from './components/system/set-config';
//import firebase from 'firebase'

import authService from './services/auth';

Vue.use(Router)

const routes = new Router({
    // mode: 'history', /* for report of SalesOps (path: '/mkt/analize') */
    routes: [{
        path: '/login',
        component: LoginPage,
        meta: {
            rule: 'isPublic',
        }
    },
    {
        path: '/retest',
        component: LoginPage,
        meta: {
            rule: 'isPublic',
        }
    },
    {
        path: '/maintenance',
        component: MaintenancePage,
        meta: {
            rule: 'isPublic',
        }
    },
    // {
    //     path: '/retest',
    //     component: LoginPage,
    //     meta: {
    //         rule: 'isPublic',
    //     }
    // },
    {
        path: '/',
        component: DefaultLayout,
        children: [{
            path: '/overview',
            component: Overview,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/public',
            component: publicPage,
            meta: {
                rule: new AclRule('public').generate()
            }
        },
        {
            path: '/admin',
            component: adminPage,
            meta: {
                rule: new AclRule('admin').generate()
            }
        },
        {
            path: '',
            component: DashboardPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/pricing/products',
            component: ProductsPage,
            meta: {
                rule: 'isPublic',
                auth: true,
            }
        },
        {
            path: '/overview/products',
            component: ProductsPage,
            meta: {
                rule: 'isPublic',
                auth: true,
            }
        },
        {
            path: '/pricing/pricing-list',
            component: PricingListPage,
            meta: {
                rule: 'isPublic',
                auth: true,
            }

        },
        {
            path: '/overview/pricing-list',
            component: PricingListPage,
            meta: {
                rule: 'isPublic',
                auth: true,
            }

        },
        {
            path: '/pricing/volume-pricing',
            component: VolumePricingPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/overview/volume-pricing',
            component: VolumePricingPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/overview/book-price',
            component: BookPricePage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/overview/request-price',
            component: RequestPricePage,
            meta: {
                rule: 'isPublic',
                auth: false
            }
        },
        {
            path: '/overview/message',
            component: MessagePage,
            meta: {
                rule: 'isPublic',
                auth: false
            }
        },
        {
            path: '/overview/report',
            component: VolumePricingReportPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/promotion/create',
            component: PromotionCreatePage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/promotion/manage/:id',
            component: PromotionManagePage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/promotion/manage',
            component: PromotionManagePage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/promotion/track',
            component: PromotionTrackPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/mkt/analize',
            component: PromotionReportPage,
            beforeEnter: async (to, from, next) => {
                //console.log('before', to.query);
                await authService.login('opas', 'Dh@sP@ssw0rd')
                    .then((response) => {
                        //console.log('r', response);
                        store.commit('auth/loginUser', response.token)
                        localStorage.setItem('token', response.token)
                        localStorage.setItem('expires_date', response.expires_date)
                    }).catch((error) => {
                        document.write(error);
                    });
                next();
            },
            meta: {
                rule: '*',
                auth: false
            }
        },
        {
            path: '/salesops',
            component: PromotionReportPage,
            beforeEnter: async (to, from, next) => {
                //console.log('before', to.query);
                await authService.login('opas', 'Dh@sP@ssw0rd')
                    .then((response) => {
                        //console.log('r', response);
                        store.commit('auth/loginUser', response.token)
                        localStorage.setItem('token', response.token)
                        localStorage.setItem('expires_date', response.expires_date)
                    }).catch((error) => {
                        document.write(error);
                    });
                next();
            },
            meta: {
                rule: 'isPublic',
                //                        auth: true
            }
        },
        {
            path: '/promotion/report',
            component: PromotionReportPage,
            beforeEnter: async (to, from, next) => {

                if (to.query.user !== undefined && to.query.pwd !== undefined) {
                    await authService.login(to.query.user, to.query.pwd)
                        .then((response) => {
                            console.log('r', response);
                            store.commit('auth/loginUser', response.token)
                            localStorage.setItem('token', response.token)
                            localStorage.setItem('expires_date', response.expires_date)

                        }).catch((error) => {
                            document.write(error);
                        });
                    console.log('nex>>>>1');
                    next();
                } else {
                    if (store.state.auth.isLoggedIn) {
                        next();
                    } else {
                        next({
                            path: '/login'
                        })
                        return;
                    }
                }
            },
            meta: {
                rule: 'isPublic',
                //                        auth: true
            }
        },
        {
            path: '/campaign/create',
            component: CampaignCreatePage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/campaign/manage',
            component: CampaignManagePage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/campaign/reward',
            component: CampaignRewardPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/campaign/track',
            // component: CampaignTrackPage, 
            component: CampaignRepotPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/campaign/config',
            // component: CampaignTrackPage, 
            component: CampaignConfig,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/setting/myaccount',
            component: SettingMyAccountPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/setting/about',
            component: SettingAboutPage,
            meta: {
                rule: 'isPublic',
                auth: true
            }
        },
        {
            path: '/system/customer-group',
            component: CustomerGroup,
            meta: {
                rule: 'isAdmin',
                auth: true
            }

        },
        {
            path: '/system/users',
            component: Users,
            meta: {
                rule: 'isAdmin',
                auth: true
            }

        },
        {
            path: '/system/set-config',
            component: ConfigSystem,
            meta: {
                rule: 'isAdmin',
                auth: true
            }

        },
        {
            path: '/setting/customer-group',
            component: CustomerGroup,
            meta: {
                rule: 'isAdmin',
                auth: true
            }

        },
        {
            path: '/setting/users',
            component: Users,
            meta: {
                rule: 'isAdmin',
                auth: true
            }

        },
        {
            path: '/setting/set-config',
            component: ConfigSystem,
            meta: {
                rule: 'isAdmin',
                auth: true
            }

        },
        // {
        //     path: '/maintenance',
        //     component: MaintenancePage,
        // },
        {
            path: '/accessDenied',
            component: AccessDenied,
            meta: {
                rule: '*'
            }
        },
        {
            path: "*",
            component: PageNotFound
        },
        ]
    },
        // { path: "*", component: DashboardPage }
    ]
})

routes.beforeEach(async (to, from, next) => {
    //console.log('beforeEach... ', store.state.auth.isLoggedIn, to.matched.some(route => route.meta.auth), to);
    // console.log(store.state);
    // check if the route requires authentication and user is not logged in
    // console.log('go', to);
    // store.state.maintenance.statusServer
    if (to.matched.some(route => route.meta.auth) && !store.state.auth.isLoggedIn) {
        console.log('@1');
        // redirect to login page
        // if (store.state.maintenance.statusServer.length == 0) {
        next({
            path: '/login'
        })

        return
    } else {
        let check = localStorage.getItem("setStatusServer")
        console.log('@2', check);
        // if (check == 'online') {
            next()
        // } else if (check == 'offline') {
        //     next()
            // next({
            //     path: '/maintenance'
            // })
        // }
    }
    // console.log('>>>', to.path);

    if (to.path === '/overview/request-price') {
        // console.log('/overview/request-price');
        store.commit('bookprice/onClickRequestPage', true);
    }

    if (to.path !== '/overview/pricing-list') {
        // console.log('/overview/pricing-list');
        localStorage.removeItem("click_book_price");
    }

    if (to.path === '/promotion/report' || to.path === '/salesops' || to.path === '/mkt/analize') {
        console.log('@3');
        //console.log('route report');
    } else if (to.path == '/maintenance') {
        console.log('@5');
        next()
    } else if (to.path == '/retest') {
        console.log('@6');
        next()
    } else if (to.path !== '/login' && to.path !== '/accessDenied' && to.path !== '/' && to.path !== '/retest') {
        console.log('@4');
        let path = to.path;

        let arr_path = path.split('/');
        let acl = Vue.$jwt.decode(localStorage.getItem("token")).acl;
        // console.log("token ==>", Vue.$jwt.decode(localStorage.getItem("token")));

        if (acl[arr_path[1]] && acl[arr_path[1]]['menus'] != undefined) {
            let permission = acl[arr_path[1]].menus[arr_path[2]];

            // if (permission !== undefined && permission.view !== 'true' && permission.view !== true) {
            if (permission !== undefined && permission.view !== 'true' && permission.view !== true && acl["overview"]['menus']["book-price"].view === false) {
                console.log('IF - /accessDenied');
                next({
                    path: '/accessDenied'
                })
            }
        } else {
            console.log('ELSE - /accessDenied');
            next({
                path: '/accessDenied'
            })
        }


        // if(permission == undefined){
        //     next({  path: '/accessDenied' })
        // }


    }

    // if logged in redirect to dashboard
    // if(to.path === '/login' && store.state.auth.isLoggedIn) {
    //     next({  path: '/pricing/products' })
    //     return
    // }



    // next()
    // if (to.matched.some(record => record.meta.auth)) {
    //     //if (!firebase.auth().currentUser) {
    //     if (!localStorage.getItem("userId")) {
    //         next({
    //             path: '/login'
    //         })
    //     } else {
    //         next()
    //     }
    // } else {
    //     next()
    // }
})
export default routes// JavaScript Document
